import { fmtINR } from "../orders/OrderShared";

export const pct = (r) => (r == null ? "—" : `${Math.round(r * 100)}%`);
export const hrs = (m) => (m?.median_hours == null ? "—" : m.median_hours >= 48 ? `${(m.median_hours / 24).toFixed(1)} d` : `${m.median_hours} h`);
export const num = (n) => (n == null ? "—" : Number(n).toLocaleString("en-IN"));
export const inr = (n) => (n == null ? "—" : fmtINR(n));

export const KpiCard = ({ label, value, hint, testId }) => (
  <div className="p-5 rounded-xl bg-card border border-border" data-testid={testId}>
    <p className="text-xs uppercase tracking-wider text-muted-foreground font-mono-tech">{label}</p>
    <p className="mt-2 text-2xl font-bold font-heading" data-testid={`${testId}-value`}>{value}</p>
    {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const KpiGrid = ({ items, cols = "sm:grid-cols-2 lg:grid-cols-4" }) => (
  <div className={`grid grid-cols-1 ${cols} gap-4`}>
    {items.map((k) => <KpiCard key={k.testId} {...k} />)}
  </div>
);

export const SectionTitle = ({ children }) => <h3 className="text-base md:text-lg font-semibold font-heading mt-8 mb-3">{children}</h3>;

export const EmptyNote = ({ testId }) => (
  <p className="text-sm text-muted-foreground p-6 rounded-xl border border-dashed border-border" data-testid={testId}>No records in this range yet. Metrics appear as RFQs and orders flow through the platform.</p>
);

export const MetricTable = ({ columns, rows, testId, rowKey }) => (
  <div className="overflow-x-auto rounded-xl border border-border" data-testid={testId}>
    <table className="w-full text-sm">
      <thead className="bg-muted/40 text-left text-xs uppercase tracking-wider text-muted-foreground">
        <tr>{columns.map((c) => <th key={c.key} className="px-4 py-2.5 font-semibold whitespace-nowrap">{c.label}</th>)}</tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={columns.length} className="px-4 py-4 text-muted-foreground">No data</td></tr>}
        {rows.map((r) => (
          <tr key={r[rowKey]} className="border-t border-border" data-testid={`${testId}-row-${String(r[rowKey]).replace(/\s+/g, "-").toLowerCase()}`}>
            {columns.map((c) => <td key={c.key} className="px-4 py-2.5 whitespace-nowrap">{c.render ? c.render(r) : r[c.key] ?? "—"}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
